/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ChannelDetailViewModel } from "../types/ChannelDetailViewModel.ts";
import { eChannelScopeTypeSchema } from "./eChannelScopeTypeSchema.ts";
import { ePlayerTypeSchema } from "./ePlayerTypeSchema.ts";

export const channelDetailViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do canal.")),
  companyId: z
    .number()
    .int()
    .describe("ID da empresa do canal. Nulo para canais globais.")
    .nullish(),
  companyName: z
    .string()
    .describe("Nome da empresa do canal. Vazio para canais globais.")
    .nullish(),
  scopeType: z.optional(
    z
      .lazy(() => eChannelScopeTypeSchema)
      .describe("1 = Course | 2 = ClassStudent | 3 = ClassroomDiscipline | "),
  ),
  scopeId: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID do dono do contexto: curso, turma ou planejamento de aula.",
      ),
  ),
  courseId: z
    .number()
    .int()
    .describe("ID do curso, quando o canal pertence ao contexto de curso.")
    .nullish(),
  classStudentId: z
    .number()
    .int()
    .describe("ID da turma, quando o canal pertence ao contexto de turma.")
    .nullish(),
  classroomDisciplineId: z
    .number()
    .int()
    .describe(
      "ID do planejamento de aula, quando o canal pertence a esse contexto.",
    )
    .nullish(),
  channelCode: z
    .string()
    .describe(
      "Código de incorporação do canal, gravado verbatim como no legado. A API não sanitiza nem renderiza o conteúdo.",
    )
    .nullish(),
  channelName: z
    .string()
    .describe("Nome do canal. Máximo de 20 caracteres.")
    .nullish(),
  videoVimeoId: z
    .string()
    .describe("ID do vídeo no Vimeo. Opcional.")
    .nullish(),
  playerType: z.optional(
    z
      .lazy(() => ePlayerTypeSchema)
      .describe("1 = Vimeo | 2 = YouTube | 3 = JWPlayer | 4 = Others | "),
  ),
  liveStreamLink: z
    .string()
    .describe("Link de transmissão ao vivo. Opcional.")
    .nullish(),
  isAudio: z.optional(z.boolean().describe("Indica se o canal é de áudio.")),
  isInternational: z.optional(
    z.boolean().describe("Indica se o canal é internacional."),
  ),
  isSubtitling: z.optional(
    z.boolean().describe("Indica se o canal tem legendagem."),
  ),
  m3U8: z.string().describe("Link da playlist M3U8. Opcional.").nullish(),
  downloadLinkHighDefinition: z
    .string()
    .describe("Link de download em alta definição. Opcional.")
    .nullish(),
  downloadLinkStandardDefinition: z
    .string()
    .describe("Link de download em definição padrão. Opcional.")
    .nullish(),
  downloadLinkLowDefinition: z
    .string()
    .describe("Link de download em baixa definição. Opcional.")
    .nullish(),
  channelDashLink: z
    .string()
    .describe(
      "Link DASH do canal. No legado era gravado pela geração automática e nunca devolvido por nenhum endpoint.",
    )
    .nullish(),
  channelDashLinkExpiration: z
    .string()
    .datetime()
    .describe(
      "Expiração do link DASH. Opcional — 4.603 canais da base têm link sem expiração gravada.",
    )
    .nullish(),
  videoDuration: z
    .number()
    .int()
    .describe(
      "Duração da mídia, em minutos. Vale também para canais de áudio: 6.647 canais de áudio da base têm duração gravada.",
    )
    .nullish(),
  recordVideoTime: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a posição de reprodução do aluno é registrada. Não se aplica a canal de áudio.",
      ),
  ),
  active: z.optional(z.boolean().describe("Indica se o canal está ativo.")),
  inactiveDate: z
    .string()
    .datetime()
    .describe(
      "Data em que o canal foi inativado. Preenchida e limpa automaticamente pelo contexto conforme a situação. Opcional.",
    )
    .nullish(),
  creationDate: z
    .string()
    .datetime()
    .describe("Data de criação. Opcional.")
    .nullish(),
  userCreation: z
    .string()
    .describe("Usuário responsável pela criação. Opcional.")
    .nullish(),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração. Opcional.")
    .nullish(),
  userLastChange: z
    .string()
    .describe("Usuário responsável pela última alteração. Opcional.")
    .nullish(),
}) as unknown as ToZod<ChannelDetailViewModel>;
